import { NumberInputProps } from 'react-admin';
import { NumberInput } from './RA';

export const MoneyInput = (props: NumberInputProps) => (
  <NumberInput {...props} />
);
